import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VuePageTransition from 'vue-page-transition'
import VueLocalForage from 'vue-localforage'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
// import './registerServiceWorker'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { 
  faUserCircle,
  faBars,
  faHome,
  faChartLine,
  faAngleDoubleDown,
  faDollarSign,
  faCashRegister,
  faTachometerAlt,
  faInfinity,
  faUsers,
  faSignInAlt,
  faBoxes,
  faSync,
  faSpinner,
  faUtensils,
  faTable,
  faUserSlash,
  faWindowClose,
  faCalendarAlt,
  faArrowLeft,
  faArrowRight,
  faUserClock,
  faUserTimes
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add([
  faUserCircle,
  faBars,
  faHome,
  faChartLine,
  faAngleDoubleDown,
  faDollarSign,
  faCashRegister,
  faTachometerAlt,
  faInfinity,
  faUsers,
  faSignInAlt,
  faBoxes,
  faSync,
  faSpinner,
  faUtensils,
  faTable,
  faUserSlash,
  faWindowClose,
  faCalendarAlt,
  faArrowLeft,
  faArrowRight,
  faUserClock,
  faUserTimes
])

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VuePageTransition)
Vue.use(VueLocalForage)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(
  VueLodash, { 
    name: 'custom' , 
    lodash: lodash 
  }
)

const moment = require('moment')
require('moment/locale/pt-br')

moment.locale('pt-br');

Vue.use(require('vue-moment'), {
  moment,
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
